import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomCheckbox, CustomDropdown, CustomModal, InputText } from '../../../../components'
import * as ReasonHttp from '../../../../services/api/https/picking/missing-reason.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_REASON: 'Salvando ocorrência',
  SUCCESS: 'Ocorrência salva com sucesso',
}

const INITIAL_STATE = {
  ocorrencia: {
    id: '',
    company_id: '',
    sigla: '',
    descricao: '',
    type: '',
    visible_picking: false,
    visible_delivery: false,
    actived: true,
    devolucao_fisica: true,
    company_code: null,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const OCCURRENCE_TYPES = [
  { label: 'Falta', value: 'Falta' },
  { label: 'Sobra', value: 'Sobra' },
]

function ModalOcorrencia({ dispatch, show, onModalClose, onModalSave, data }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    setState(prevState => ({ ...prevState, ocorrencia: { ...data } }))
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE_REASON:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        saveMissingReason(state.ocorrencia)
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        onModalSave(state.ocorrencia)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const saveMissingReason = ocorrencia => {
    ReasonHttp.saveMissingReason(ocorrencia)
      .then(ocorrencia =>
        setState(prevState => ({
          ...prevState,
          ocorrencia: ocorrencia,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: errorHandler(err),
        })),
      )
  }

  // Events
  const onFormContentChange = (name, value) => {
    setState(prevState => {
      if (name === 'company_id') prevState.ocorrencia.company_id = value.id
      else prevState.ocorrencia[name] = value
      return { ...prevState }
    })
  }

  const onBtnSalvarClicked = async () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_REASON }))
  }

  return (
    <CustomModal header="Ocorrência de Produto" isVisible={show} onClose={onModalClose} width={800}>
      <form className="p-grid">
        <div className="p-col-3">
          <InputText
            label="Sigla :"
            marginTop={10}
            value={state.ocorrencia.sigla}
            onChange={value => onFormContentChange('sigla', value)}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="Código Interno :"
            marginTop={10}
            value={state.ocorrencia.company_code || ''}
            onChange={value => onFormContentChange('company_code', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Descrição :"
            marginTop={10}
            value={state.ocorrencia.descricao}
            onChange={value => onFormContentChange('descricao', value)}
          />
        </div>

        <div className="p-col-3">
          <CustomDropdown
            options={OCCURRENCE_TYPES}
            value={state.ocorrencia.type}
            onChange={value => onFormContentChange('type', value)}
            label="Tipo de Ocorrência"
          />
        </div>
        <div className="p-col-3" style={{ paddingTop: 43 }}>
          <CustomCheckbox
            checked={state.ocorrencia.visible_picking}
            onChange={value => onFormContentChange('visible_picking', value)}
          >
            Etapa Separação
          </CustomCheckbox>
        </div>
        <div className="p-col-3" style={{ paddingTop: 43 }}>
          <CustomCheckbox
            checked={state.ocorrencia.visible_delivery}
            onChange={value => onFormContentChange('visible_delivery', value)}
          >
            Etapa Entrega
          </CustomCheckbox>
        </div>
        <div className="p-col-3" style={{ paddingTop: 43 }}>
          <CustomCheckbox
            checked={state.ocorrencia.devolucao_fisica}
            onChange={value => onFormContentChange('devolucao_fisica', value)}
          >
            Devolução Física
          </CustomCheckbox>
        </div>
        <div className="p-col-3" style={{ paddingTop: 20 }}>
          <CustomCheckbox
            checked={state.ocorrencia.actived}
            onChange={value => onFormContentChange('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12" style={{ paddingTop: 30 }}>
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalOcorrencia)
